import { useCallback } from 'react';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { commonEventData } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/constants/license-plate-tracking';

/**
 * Centralizes the License Plate tab tracking events so the submit hook stays
 * focused on flow orchestration rather than event payload construction.
 */
export function useLicensePlateTracking(creativeId) {
  const fireTrackAction = useCallback(
    (eventType, subactionName, value, extraEventData = {}) => {
      EventToolbox.fireTrackAction({
        event_type: eventType,
        event_data: {
          ...commonEventData,
          ...extraEventData,
          subaction_name: subactionName,
          creative_id: creativeId,
          value,
        },
      });
    },
    [creativeId]
  );

  const fireLicensePlateLookupTracking = useCallback(
    value => fireTrackAction(TrackingConstant.EVENT_TYPE_ACTION_PROGRESS, TrackingConstant.LICENSE_PLATE_LOOKUP, value),
    [fireTrackAction]
  );

  const fireVinDecodeError = useCallback(
    value =>
      fireTrackAction(TrackingConstant.EVENT_TYPE_ACTION_PROGRESS, TrackingConstant.SUBACTION_VIN_ERROR, value, {
        action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      }),
    [fireTrackAction]
  );

  return { fireTrackAction, fireLicensePlateLookupTracking, fireVinDecodeError };
}
